import privateBusRequests from "./privateBusRequests.component";
import privateBusRequestsUrls from "./privateBusRequests.urls";
import PrivateBusRequestsTransforms from "./privateBusRequests.transforms";

const privateBusRequestsModule = angular
  .module("app.components.privateBusRequests", [])
  .component("privateBusRequestsPage", privateBusRequests)
  .service("PrivateBusRequestsTransforms", PrivateBusRequestsTransforms)
  .config(privateBusRequestsUrls);

export default privateBusRequestsModule;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequests/privateBusRequests.module.js